import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useAdminStore } from '../../stores/useAdminStore';
import { useViewerModeStore } from '../../stores/useViewerModeStore';
import { useResponsiveDesign } from '../../hooks/useResponsiveDesign';
import Button from '../ui/Button/Button';
import { EventCreateModal } from './EventCreateModal';
import { EventActionsModal } from './EventActionsModal';
import { SeasonCreateModal } from './SeasonCreateModal';
import { SeasonActionsModal } from './SeasonActionsModal';
import './AdminMode.css';

export const AdminMode: React.FC = () => {
  const {
    isAdminMode,
    toggleAdminMode,
    showEventActionsModal,
    selectedEvent,
    closeEventActionsModal
  } = useAdminStore(
    useShallow(s => ({
      isAdminMode: s.isAdminMode,
      toggleAdminMode: s.toggleAdminMode,
      showEventActionsModal: s.showEventActionsModal,
      selectedEvent: s.selectedEvent,
      closeEventActionsModal: s.closeEventActionsModal,
    }))
  );
  const { isMobile } = useResponsiveDesign();
  const mode = useViewerModeStore(s => s.mode);

  // Hidden on mobile; family mode has no admin entry point at all.
  if (isMobile || mode === 'family') {
    return null;
  }

  return (
    <>
      <div className="admin-mode-container" data-testid="admin-mode-container">
        <Button
          variant="theme-toggle"
          size="medium"
          onClick={toggleAdminMode}
          aria-label={`${isAdminMode ? 'Exit' : 'Enter'} admin mode`}
          data-testid="admin-toggle"
        >
          {isAdminMode ? '❌ Exit Admin' : '⚙️ Admin Mode'}
        </Button>
      </div>

      {/* All modals - no AdminPanel */}
      <EventCreateModal />
      <EventActionsModal
        isOpen={showEventActionsModal}
        event={selectedEvent}
        onClose={closeEventActionsModal}
      />
      <SeasonCreateModal />
      <SeasonActionsModal />
    </>
  );
};
